import React, { Component } from 'react';
import ClientRevenueCard from './Cards/ClientRevenueCard';
import FieldworkCycleCard from './Cards/FieldworkCycleCard';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TierService from '../../../Services/TierService';
import PricingDetailService from '../../../Services/PricingDetailService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TierItemList from '../../../Domain/TierItemList';
import TierItem from '../../../Domain/TierItem';
import MarkUpCard from './Cards/MarkUpCard';
import ShopperTravelCostCard from './Cards/ShopperTravelCostCard';
import EvaluatorFeeCard from './Cards/EvaluatorFeeCard';
import OtherMiscCostsCard from './Cards/OtherMiscCostsCard';
import EditingCostCard from './Cards/EditingCostCard';
import EmployeeCostCard from './Cards/EmployeeCostCard';
import OtherDirectCostsCard from './Cards/OtherDirectCostsCard';
import PricingDetailStatus from './Cards/PricingDetailStatus';
import VideoCostsCard from './Cards/VideoCostsCard';
import CostSplitCard from './Cards/CostSplitCard';
import StatusBarCard from './Cards/StatusBarCard';
import PricingDetailSearchParams from './PricingDetailSearchParams';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import VPricingDetailBaseItem from '../../../Domain/VPricingDetailBaseItem';
import Loading from '../../../Elements/loading';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import TierItemListForOverall from '../../../Domain/TierItemListForOverall';

class PricingDetailAdmin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tierList: new TierItemList(),
      overallTierList: new TierItemList(),
      pricingDetail: null,
      shownPanel: ShownPanelsEnum.None,
      loadingTier: false,
      searchItem: new PricingDetailSearchParams(),
      // pricingDetailForTotal: null,
    };

    this.onChange = this.onChange.bind(this);
    this.clickOnButton = this.clickOnButton.bind(this);
    this.addNewTier = this.addNewTier.bind(this);

    FieldworkCycleCard.RemoveTier = this.removeTier.bind(this);
    this.removeTierFromDb = this.removeTierFromDb.bind(this);
    this.onChangePricingDetail = this.onChangePricingDetail.bind(this);
  }

  clickOnButton(panelId) {
    if (panelId === ShownPanelsEnum.EditGlobal) {
      this.setState({ loadingTier: true });
      TierService.Post(this.state.tierList.TierList)
        .then((result) => {
          if (result.error) {
            ErrorMessage.SetErrorMessage(result.error);
            this.setState({ loadingTier: false });
            return;
          }
          PricingDetailService.Post(this.state.tierList.PricingDetails)
            .then((res) => {
              if (res.error) {
                ErrorMessage.SetErrorMessage(res.error);
                this.setState({ loadingTier: false });
                return;
              }
              this.populatePricingDetail();
              ErrorMessage.SetSuccess(
                'The pricing version has been saved. For the result see your personal notification page.'
              );
            })
            .catch(() => {
              ErrorMessage.SetErrorMessage('PDA126');
              this.setState({ loadingTier: false });
            });
        })
        .catch(() => {
          ErrorMessage.SetErrorMessage('PDA118');
          this.setState({ loadingTier: false });
        });
    } else if (panelId == ShownPanelsEnum.Refresh) {
      this.populatePricingDetail(true);
    }
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  componentDidMount() {
    this.populatePricingDetail();
  }

  populatePricingDetail(clearCache = false) {
    if (!this.state.searchItem.PricingDetailId) return;
    this.setState({ loadingTier: true });
    PricingDetailService.GetPricingDetail(this.state.searchItem.PricingDetailId, clearCache)
      .then((result) => {
        if (!result) {
          this.setState({
            pricingDetail: null,
            loadingTier: false,
          });
          return;
        }
        const pricingDetail = PricingDetailService.ConvertDBSingleItem(result);

        // const pricingDetailForTotal = {
        //   ...pricingDetail,
        //   CurrencyCode: pricingDetail.OpportunityCurrencyCode,
        //   CurrencySymbol: pricingDetail.OpportunityCurrencySymbol,
        //   CurrencyRate: 1,
        // };
        this.setState({ pricingDetail /*, pricingDetailForTotal */ });
        this.populateTierList();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('PDA72');
        this.setState({ loadingTier: false });
      });
  }

  populateTierList() {
    TierService.GetTierList({
      PricingDetailId: this.state.searchItem.PricingDetailId,
      OverallTierListSearch: false,
    })
      .then((result) => {
        const convertedResult = TierService.CalculateTier(result, this.state.pricingDetail);
        const tierList = new TierItemList(convertedResult, this.state.pricingDetail);

        this.setState({
          tierList,
          loadingTier: false,
        });
      })
      .then(() => {
        TierService.GetTierList({
          PricingDetailId: this.state.searchItem.PricingDetailId,
          OverallTierListSearch: true,
        })
          .then((overallResult) => {
            // Get VPricingDetailBase for each result item to calculate correctly
            PricingDetailService.GetPricingDetailList(
              overallResult.map((t) => t.pricingDetailId),
              true
            ).then((pricingDetailListForOverall) => {
              const pdetails = PricingDetailService.ConvertDBItem(pricingDetailListForOverall);

              // Map each overallResult.pricingDetail to the correct pricingDetail from pricingDetailListForOverall
              overallResult.forEach((item) => {
                item.pricingDetail = pdetails.find((pd) => pd.PricingDetailId === item.pricingDetailId);
              });

              // Pass correct pricingDetail from view in object to CalculateOverallTier
              const convertedOverallResult = TierService.CalculateOverallTier(overallResult);
              // console.log(convertedOverallResult, 'Converted Overall Tier List');

              const currentPricingDetail = this.state.tierList.PricingDetails;

              // Call TierItemListForOverall for each item in convertedOverallResult
              const overallTierList = new TierItemListForOverall(convertedOverallResult, currentPricingDetail);

              // console.log(overallTierList, 'Overall Tier List Object');

              this.setState({ overallTierList });
            });
          })
          .catch((error) => {
            ErrorMessage.SetErrorMessage('PDA100');
          });
      })

      .catch((error) => {
        ErrorMessage.SetErrorMessage('PDA100');
        this.setState({ loadingTier: false });
      });
  }

  removeTierFromDb(tierId) {
    const temp = { ...this.state.tierList };
    const index = temp.TierList.find((c) => c.TierId === parseInt(tierId));
    temp.TierList.splice(index, 1);

    TierService.Remove(tierId)
      .then((result) => {
        temp.Calculate();
        this.setState({ tierList: temp });
        ErrorMessage.SetNotification('Success!');
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('PDA88');
      });
  }

  onChange(fieldName, newValue, index) {
    const temp = this.state.tierList;

    temp.TierList[index][fieldName] = newValue;
    temp.TierList[index].calculate(this.state.pricingDetail);

    temp.Calculate();

    const tempOverall = this.state.overallTierList;

    const overallIndex = tempOverall.TierList.findIndex((t) => t.TierId === temp.TierList[index].TierId);

    if (overallIndex !== -1) {
      tempOverall.TierList[overallIndex][fieldName] = newValue;
      tempOverall.TierList[overallIndex].calculate(tempOverall.TierList[overallIndex].VPricingDetailBaseItem);
      tempOverall.Calculate();
    }

    this.setState({ tierList: temp, overallTierList: tempOverall });
  }

  addNewTier() {
    const temp = this.state.tierList;
    const tierList = new TierItem({
      name: `Default Tier ${1 + this.state.tierList.TierList.length}`,
      pricingDetailId: this.state.pricingDetail.PricingDetailId,
      numEvalsPerCycle: 0,
      clientFeePerEval: 0,
      markUpPct: VPricingDetailBaseItem.ConvertToDecimal(0),
      markedUpFeePerEval: '',
      markUpPerTier: '',
      evalFeePerEval: '',
      markUpPerEval: '',
      travelCostPerCycle: '',

      currencySymbol: this.state.pricingDetail.CurrencySymbol,
      numEvalsPerYear: 0,
    });

    tierList.calculate(this.state.tierList.PricingDetails);
    temp.TierList.push(tierList);
    temp.Calculate();

    const overallTemp = this.state.overallTierList;

    const currentPricingDetail = this.state.tierList.PricingDetails;
    // find a tier from the overall tierlist with the same pricingdetail id and get it in a const
    const pricingMatchFromOverall = this.state.overallTierList.TierList.find(
      (t) => t.PricingDetailId === this.state.pricingDetail.PricingDetailId
    );
    const pricingDetailForTier = pricingMatchFromOverall?.VPricingDetailBaseItem || currentPricingDetail;

    const overallTierList = new TierItem({
      name: `Default Tier ${1 + this.state.overallTierList.TierList.length}`,
      pricingDetailId: this.state.pricingDetail.PricingDetailId,
      numEvalsPerCycle: 0,
      clientFeePerEval: 0,
      markUpPct: VPricingDetailBaseItem.ConvertToDecimal(0),
      markedUpFeePerEval: '',
      markUpPerTier: '',
      evalFeePerEval: '',
      markUpPerEval: '',
      travelCostPerCycle: '',
      currencySymbol: this.state.pricingDetail.CurrencySymbol,
      pricingDetail: pricingDetailForTier,
      numEvalsPerYear: 0,
    });
    overallTierList.VPricingDetailBaseItem = pricingDetailForTier;

    overallTierList.calculate(overallTierList.VPricingDetailBaseItem);
    overallTemp.TierList.push(overallTierList);
    overallTemp.Calculate();

    this.setState({ tierList: temp, overallTierList: overallTemp, shownPanel: ShownPanelsEnum.None });
  }

  onChangePricingDetail(fieldName, newValue) {
    const temp = this.state.pricingDetail;
    temp[fieldName] = newValue; //Changed to be done regardless of special cases CD-3973
    if (
      [
        'ProjMgrDailyCostOverride',
        'TeamLeadDailyCostOverride',
        'OperationsMgrDailyCostOverride',
        'AssistantProjMgrDailyCostOverride',
        'PanelMgrRecruiterDailyCostOverride',
        'EditDataCheckDailyCostOverride',
      ].includes(fieldName) &&
      newValue === false
    ) {
      const baseFieldName = fieldName.replace('Override', '');
      temp[baseFieldName] = temp[`${baseFieldName}Office`];
    } else if (
      [
        'TeamLeadDailyCostOverrideCur',
        'ProjMgrDailyCostOverrideCur',
        'OperationsMgrDailyCostOverrideCur',
        'AssistantProjMgrDailyCostOverrideCur',
        'PanelMgrRecruiterDailyCostOverrideCur',
        'EditDataCheckDailyCostOverrideCur',
      ].includes(fieldName)
    ) {
      const baseFieldName = fieldName.replace('OverrideCur', '');
      temp[baseFieldName] = newValue / this.state.pricingDetail.CurrencyRate;
      //Added in CD-3930
    } else if (['SMCostPerEvalConv'].includes(fieldName)) {
      const baseFieldName = fieldName.replace('Conv', '');
      temp[fieldName] = newValue;
      temp[baseFieldName] = newValue / this.state.pricingDetail.CurrencyRate;
    }

    const { tierList } = this.state;
    tierList.Calculate();

    this.setState({ pricingDetail: temp, tierList });
  }

  removeTier(tierId) {
    ErrorMessage.SetApprove('You will remove this tier.', () => this.removeTierFromDb(tierId));
  }

  renderButtonsAndPanels() {
    if (this.state.pricingDetail.Status === 'Final') {
      return null;
    }
    if (
      (Array.isArray(this.state.pricingDetail) && this.state.pricingDetail.length === 0) ||
      this.state.pricingDetail.PricingDetailId === ''
    )
      return null;

    return (
      <FigmaButtonRow
        className={'ButtonRowInHeader'}
        buttons={[
          {
            iconName: 'fa-solid fa-refresh',
            type: ButtonTypeEnum.NormalIconOnly,
            tooltip: 'Refresh',
            color: ButtonColorsEnum.Common,
            iconPosition: IconPositionEnum.Center,
            disabled: this.props.Status,
            onClick: () => this.clickOnButton(ShownPanelsEnum.Refresh),
          },
          {
            type: ButtonTypeEnum.NormalNormal,
            color: ButtonColorsEnum.Primary,
            iconPosition: IconPositionEnum.None,
            label: 'Save',
            onClick: () => this.clickOnButton(ShownPanelsEnum.EditGlobal),
          },
        ]}
      />
    );
  }

  static UserCanMarkup(opportunityOfficeId, fieldworkOfficeId) {
    if (opportunityOfficeId === undefined || fieldworkOfficeId === undefined) return true;

    return opportunityOfficeId !== fieldworkOfficeId;
  }

  renderError() {
    return (
      <div className='contentwrapper pd-redesign'>
        <div className='m-3 p-3 border rounded bg-danger text-white lead'>
          <div>There is no such pricing detail.</div>
        </div>
      </div>
    );
  }

  renderPricingDetailStatus() {
    return (
      <PricingDetailStatus
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
        RemoveTier={this.removeTier}
      />
    );
  }

  renderFieldworkCycleCard() {
    return (
      <FieldworkCycleCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
        AddTier={this.addNewTier}
        RemoveTier={this.removeTier}
      />
    );
  }

  renderClientRevenueCard() {
    return (
      <ClientRevenueCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderMarkUpCard() {
    // return PricingDetailAdmin.UserCanMarkup(this.state.pricingDetail.OpportunityOfficeId) ?  (
    return (
      <MarkUpCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
        UserCanMarkup={PricingDetailAdmin.UserCanMarkup(
          this.state.pricingDetail.OpportunityOfficeId,
          this.state.pricingDetail.OfficeId
        )}
      />
    );
  }

  renderEvaluatorFeeCard() {
    return (
      <EvaluatorFeeCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderShopperTravelCostCard() {
    return (
      <ShopperTravelCostCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderOtherMiscCostsCard() {
    return (
      <OtherMiscCostsCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderEditingCostCard() {
    return (
      <EditingCostCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderEmployeeCostCard() {
    return (
      <EmployeeCostCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderOtherDirectCostsCard() {
    return (
      <OtherDirectCostsCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderVideoCostsCard() {
    return (
      <VideoCostsCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
      />
    );
  }

  renderCostSplitCard() {
    return (
      <CostSplitCard
        Tier={this.state.tierList}
        pricingDetail={this.state.pricingDetail}
        onChange={this.onChange}
        onChangePricingDetail={this.onChangePricingDetail}
        UserCanMarkup={PricingDetailAdmin.UserCanMarkup(
          this.state.pricingDetail.OpportunityOfficeId,
          this.state.pricingDetail.OfficeId
        )}
      />
    );
  }

  renderStatusBarCard() {
    const userCanMarkup = PricingDetailAdmin.UserCanMarkup(
      this.state.pricingDetail.OpportunityOfficeId,
      this.state.pricingDetail.OfficeId
    );
    return (
        <StatusBarCard
          Tier={this.state.tierList}
          OverallTier={this.state.overallTierList}
          pricingDetail={this.state.pricingDetail}
          onChange={this.onChange}
          onChangePricingDetail={this.onChangePricingDetail}
          UserCanMarkup={userCanMarkup}
        />
    );
  }

  render() {
    if (this.state.loadingTier) return <Loading />;
    if (!this.state.pricingDetail || !this.state.tierList || !this.state.tierList.PricingDetails) {
      return this.renderError();
    }
    return (
      <div className='contentwrapper pd-redesign'>
        {this.renderButtonsAndPanels()}
        {this.renderPricingDetailStatus()}
        {this.renderFieldworkCycleCard()}
        {this.renderClientRevenueCard()}
        {this.renderMarkUpCard()}
        {this.renderEvaluatorFeeCard()}
        {this.renderShopperTravelCostCard()}
        {this.renderOtherMiscCostsCard()}
        {this.renderEditingCostCard()}
        {this.renderEmployeeCostCard()}
        {this.renderOtherDirectCostsCard()}
        {this.renderVideoCostsCard()}
        {this.renderCostSplitCard()}
        <div className='CostSplitCardFooter' />
        {this.renderStatusBarCard()}
      </div>
    );
  }
}

export default PricingDetailAdmin;
